import ApiService from './ApiService';

export default {
  findById(id) {
    return new Promise((resolve, reject) => {
      const data = {
        id,
        includes: 'marketplace',
      };
      ApiService.request('GET', 'marketplaces/categories', data).then((response) => {
        if (response.status === 200 && response.data.length === 1) {
          resolve(response.data[0]);
        } else {
          reject(new Error());
        }
      }).catch(() => {
        reject(new Error());
      });
    });
  },
  update(id, data) {
    return new Promise((resolve, reject) => {
      ApiService.request('PUT', `marketplaces/categories/${id}`, data).then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(new Error());
        }
      }).catch(() => {
        reject(new Error());
      });
    });
  },
};
